import { render, staticRenderFns } from "./SplashFooter.vue?vue&type=template&id=79ffd461&scoped=true&"
import script from "./SplashFooter.vue?vue&type=script&lang=ts&"
export * from "./SplashFooter.vue?vue&type=script&lang=ts&"
import style0 from "./SplashFooter.vue?vue&type=style&index=0&id=79ffd461&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ffd461",
  null
  
)

export default component.exports